/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type TestServerConnectionRequestBody = {
  /**
   * Exact MCP server to test.
   */
  mcpServerId: string;
};

/** @internal */
export type TestServerConnectionRequestBody$Outbound = {
  mcp_server_id: string;
};

/** @internal */
export const TestServerConnectionRequestBody$outboundSchema: z.ZodMiniType<
  TestServerConnectionRequestBody$Outbound,
  TestServerConnectionRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function testServerConnectionRequestBodyToJSON(
  testServerConnectionRequestBody: TestServerConnectionRequestBody,
): string {
  return JSON.stringify(
    TestServerConnectionRequestBody$outboundSchema.parse(
      testServerConnectionRequestBody,
    ),
  );
}
